
import { i18nText } from '@/locales';
export class PaymentCreateFormData {
    payment_method_id: number | null;
    staff_id: number | null;
    client_id: number;
    salon_id: number | null;
    sum: number;
    cashbox_id: number | null
    constructor() {
        this.payment_method_id = null;
        this.staff_id = null;
        this.client_id = 0;
        this.salon_id = null;
        this.sum = 0;
        this.cashbox_id = 0
    }
}
const checkToNumber = (field: unknown, value: string | number): boolean => value == Number(value) ? true : false;
const checkNegative = (field: unknown, value: number): boolean => value > 0 ? true : false

export const FormRules = {
    sum: [
        { required: true, message: i18nText("Пожалуйста укажите сумму"), trigger: "change" },
        { validator: checkToNumber, message: i18nText("Пожалуйста введите только цифры"), trigger: "change" },
        { validator: checkNegative, message: i18nText("Сумма не может быть отрицательной"), trigger: "change" }
    ],
    payment_method_id: [{ required: true, message: i18nText("Пожалуйста укажите категорию"), trigger: "change" }],
    staff_id: [{ required: true, type: 'number', min: 1, message: i18nText("Пожалуйста укажите сотрудника"), trigger: "change" }],
    cashbox_id: [{ required: true, type: 'number', min: 1, message: i18nText("Пожалуйста укажите кассу"), trigger: "change" }],
};
